import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchTopBarLocationList = async (params = {}) => {
  try {
    const qs = reqTransform.fetchTopBarLocationList(params);
    const url = `${baseUrl}/BioFuelRegistration/api/BusinessProfile/FetchBusinessAndAffiliateLocationsAgainstPersonId_ELOC_PhaseTwo?${qs}`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchTopBarLocationList(resData);
  } catch (err) {
    console.log('fetchTopBarLocationList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'fetchTopBarLocationList');
    throw errors;
  }
};
